import { useCallback } from 'react';
import { useEditorStore } from '~/shell/Store';
import { FormData } from '~/training/sequence/templates/items/chatBot/components/forms/AIScenarioForm';
import {
  createChatBotPayload,
  createUpdateChatBotPayload
} from '~/training/sequence/templates/items/chatBot/utils/chatBotHelpers';

export const useChatBotActions = (
  sequenceId: string | undefined,
  itemId: string,
  resetForm: () => void
) => {
  const createNewChatBot = useCallback(
    async (formData: FormData) => {
      const { apiService, updateSubItem } = useEditorStore.getState();

      if (!apiService) {
        throw new Error('API service not available');
      }

      if (!formData.selectedTemplate) {
        console.warn('No template selected for chatbot creation');
        return false;
      }

      const response = await apiService.createChatBotFromTemplate(
        formData.selectedTemplate,
        createChatBotPayload(formData)
      );

      if (!response.error) {
        try {
          if (itemId) {
            const attachResponse = await updateSubItem(
              itemId,
              'item_bots_attributes',
              [
                {
                  conversation_bot_id: response.id
                }
              ]
            );

            if (!attachResponse.error) {
              resetForm();
              return true;
            }
          }
        } catch (error) {
          console.error('Error attaching bot to subitem:', error);
        }

        return false;
      }

      return false;
    },
    [sequenceId, itemId, resetForm]
  );

  const updateExistingChatBot = useCallback(
    async (formData: FormData, chatBotId: string) => {
      const { apiService } = useEditorStore.getState();

      if (!apiService) {
        throw new Error('API service not available');
      }

      const response = await apiService.updateChatBot(
        chatBotId,
        createUpdateChatBotPayload(formData)
      );

      if (!response.error) {
        resetForm();
        return true;
      }

      return false;
    },
    [resetForm]
  );

  return {
    createNewChatBot,
    updateExistingChatBot
  };
};
